import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AnalysisStateService, RegionSelectionSummary, UploadedFileMetadata } from '../../services/analysisState.service';
import { TopbarRegionInfoComponent } from '../topbar-region-info/topbar-region-info.component';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule, TopbarRegionInfoComponent],
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {
  isFileUploaded$: Observable<boolean>;
  regionSelection$: Observable<RegionSelectionSummary | null>;
  uploadedFileMetadata$: Observable<UploadedFileMetadata | null>;

  constructor(private analysisStateService: AnalysisStateService, private router: Router) {
    this.isFileUploaded$ = this.analysisStateService.fileUploaded$;
    this.regionSelection$ = this.analysisStateService.regionSelection$;
    this.uploadedFileMetadata$ = this.analysisStateService.uploadedFileMetadata$;
  }

  goHome(event: MouseEvent): void {
    event.preventDefault();
    if (this.router.url !== '/') {
      this.analysisStateService.triggerReset();
    }
    void this.router.navigateByUrl('/');
  }

  goGuide(event: MouseEvent): void {
    event.preventDefault();
    void this.router.navigateByUrl('/guide');
  }

  newAnalysis(event: MouseEvent): void {
    event.preventDefault();
    this.analysisStateService.triggerReset();
  }
}
